type Props = {
	isOpen: boolean,
	className?: string,
	children: any
	type: string
}

const Alert = (props: Props) => {
		return (
			props.isOpen ? (
				<div className={`alert alert-${props.type} ${props.className ? props.className : ""}`}>
					{props.children}
				</div>
			) : null
		)
};

export default Alert;
